//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  head(){
    return {
      title: 'Focomotor - Tu lugar para comprar y vender vehículos',
      scripts: [
        { hid: 'adsense', src: 'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js', defer: true, 'data-ad-client': 'ca-pub-5902667990414861' },
      ]
    }
  },
  mounted(){
    this.$nextTick(() => {
      try {
        // this is required for each ad slot (calling this once will only load 1 ad)
        (window.adsbygoogle = window.adsbygoogle || []).push({})
      } catch (error) {
        console.error(error)
      }
    })
  },
  async asyncData({ $axios }){
    const data = {
        categories: [],
        brands: [],
        models: [],

        cities: [],
    }

    var vehicles

    await Promise.all([
        $axios.$get('categories').then(r => data.categories=r),
        $axios.$get('filter/brands/autos-y-camionetas').then(r => data.brands=r),
        $axios.$get('filter/allCities').then(r => data.cities=r),
        $axios.$get('vehicles/home').then(r => vehicles=r),
    ])

    console.log(data)
    return {vehicles, data}
  },
}
